export const initialState = {
  billClassId: 0,
  billClassData: [],
  searchBill: [],
  searchGridData: [],
  showSearchGrid: false,
  removeBill: [],
  isExpanded: true,
  alertBoxOpen: false, 
  isModalOpen: false,
  addName: '',
  addDescription: '',
  isBillClassAdded: false,
  isBillClassAddDataFetched: false,
  isBillClassDataFetched: false,
  billClassCount:0,
  isBillClassDataFound:false,
  isBillClassSearchDataFound:false,
  isBillClassRemoved:false,
  selectedData: {
    name: '',
    description: '',
    lastModifiedDate: '0001-01-01T00:00:00',
    pageNumber: 1,
    pageSize: 50,
  },
  isBillClassSearched:false,
  loadingRemoval:false,
  isBillClassNotRemoved: '',
};
